export default __webpack_public_path__ + "static/media/FRManagement.ca05c489.svg";